
import { OptionMenu } from "../prm/option-menu";
import { Name } from "../prm/name";
import { identification_documents } from "../identification_documents.json";
import {string_cmp} from "../js-utils";

class IdentificationDocumentsMenu extends OptionMenu {

  constructor(name) {
    super(name);
    this.fake = true;

    Object.keys(identification_documents).forEach(key => {
      this.menu.push(
        new Name(key, identification_documents[key]));
    });
    this.menu.sort((name_a, name_b) => string_cmp(name_a.label, name_b.label));
  }
}

export { IdentificationDocumentsMenu };
